/* eslint-disable */
import React from 'react';
import { ImageSelect } from '../_shared/ImageSelect';

const OPTIONS = [
  { id: 'fade' }, { id: 'undercut' }, { id: 'buzz' }, { id: 'pompadour' }, { id: 'curly' }, { id: 'crop' },
  { id: 'manBun' }, { id: 'waves' }, { id: 'curtainBangs' }, { id: 'curlyVolume' }, { id: 'slickBack' }, { id: 'other' },
];

function Page() {
  return (
    <ImageSelect
      page="hairstyle-style-like"
      progress={26}
      field="hairstyleStyleLike"
      setter="setHairstyleStyleLike"
      ns="hairstyleStyleLike"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
